import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";

// utilities
import Groups from "../pages/utilities/Groups/Groups";
import Group from "../pages/utilities/Groups/Group";
import Companies from "../pages/utilities/Companies/Companies";
import Schools from "../pages/utilities/Schools/Schools";
import Students from "../pages/fees/Students/Students";
import Configurations from "../pages/utilities/Configurations/Configurations";
import Users from "../pages/utilities/Users/Users";
import Login from "../pages/auth/Login/Login";
import ForgetPassword from "../pages/auth/ForgetPassword/ForgetPassword";
import ChartOfAccounts from "../pages/finances/ChartOfAccounts/ChartOfAccounts";
import CsvUpload from "../pages/utilities/CsvUpload/CsvUpload";
import Dashboard from "../pages/dashboard/Dashboard";
import Forms from "../pages/utilities/Forms/Forms";
import Invoices from "../pages/fees/Invoices/Invoices";
import ReceiptHeaders from "../pages/fees/Receipts/ReceiptHeaders";
import Journals from "../pages/fees/Journals/Journals";
import Vouchers from "../pages/fees/Vouchers/Vouchers";
import DebitNotes from "../pages/fees/DebitNotes/DebitNotes";
import CreditNotes from "../pages/fees/CreditNotes/CreditNotes";
import Discounts from "../pages/fees/Discount/Discounts";
import Reports from "../pages/reports/Reports";
import DailyFeeCollections from "../pages/reports/DailyFeeCollections";
import OutStandingFees from "../pages/reports/OutStandingFees";

const Router = () => {
    const routes = useRoutes([
        {
            path: '/auth',
            element: <DashboardLayout />,
            children: [
                { element: <Navigate to="/auth/companies" />, index: true },
                { path: 'dashboard', element: <Dashboard /> },
                { path: 'roles', element: <Groups /> },
                { path: 'role', element: <Group /> },
                { path: 'role/:id', element: <Group /> },
                { path: "configurations", element: <Configurations /> },
                { path: 'companies', element: <Companies /> },
                { path: 'schools', element: <Schools /> },
                { path: 'users', element: <Users /> },
                { path: 'students', element: <Students /> },
                { path: 'csv_upload', element: <CsvUpload /> },
                { path: 'chart_of_accounts', element: <ChartOfAccounts /> },
                { path: 'invoices', element: <Invoices /> },
                { path: 'receipts', element: <ReceiptHeaders /> },
                { path: 'journals', element: <Journals /> },
                { path: 'forms', element: <Forms /> },
                { path: 'vouchers', element: <Vouchers /> },
                { path: 'debit_notes', element: <DebitNotes /> },
                { path: 'credit_notes', element: <CreditNotes /> },
                { path: 'discounts', element: <Discounts /> },
                { path: 'reports', element: <Reports /> },
                { path: 'reports/daily_fee_collection', element: <DailyFeeCollections /> },
                { path: 'reports/outstanding_fees', element: <OutStandingFees /> }
            ],
        },
        {
            path: '/',
            element: <Login />,
        },
        {
            path: '/forgot_password',
            element: <ForgetPassword />,
        },
        // {
        //   element: <SimpleLayout />,
        //   children: [
        //     { element: <Navigate to="/dashboard/app" />, index: true },
        //     { path: '404', element: <Page404 /> },
        //     { path: '*', element: <Navigate to="/404" /> },
        //   ],
        // },
        // {
        //   path: '*',
        //   element: <Navigate to="/404" replace />,
        // },
    ]);
    return routes;
};

export default Router;